__turbopack_context__.v({
  "className": "inter_a705f60e-module__qPwtVq__className",
  "variable": "inter_a705f60e-module__qPwtVq__variable",
});
